<div class="scrollable-container">
  <app-table [data]="tableData()"
             [testIdRowKey]="'articleNo'"
             (rowDoubleClick)="executeArticleAction($event)"
             (selectedRowChange)="selectedArticle.set($event)"
             [selectedRow]="selectedArticle()"
  >
    @if (showArticleImage()) {
      <app-table-column header="" width="5rem">
        <ng-template let-row>
          <img class="img" [src]="row.image" onerror="this.src='/assets/productimages/no-image.png'" alt="article preview">
        </ng-template>
      </app-table-column>
    }
    @for (column of tableColumns(); track column) {
      <app-table-column header="{{ column.title | translate }}" [width]="column.stretch ? '1fr' : 'auto'">
        <ng-template let-row>
          @if (column.dataKey === 'articleNo') {
            <a class="d-flex align-items-center gap-2" (click)="openShopLink(row.article[column.dataKey])">
              <app-svg-icon type="external-link" size="small"/>
              <strong>{{ row.article[column.dataKey] }}</strong>
            </a>
          } @else {
            {{ row.article[column.dataKey] }}
          }
        </ng-template>
      </app-table-column>
    }
    <app-table-column header="" width="min-content">
      <ng-template let-row>
        <div class="input-container">
          @if (row.count !== undefined) {
            <input
              inputRestricter="^([1-9]|([1-9][0-9])|([1-9][0-9][0-9]))?$"
              spellcheck="false"
              [value]="row.count"
              (inputEvent)="row.count = parseInt($event)"
              type="text"
              (keydown.enter)="executeArticleAction(row)"
              class="article-count"
              [id]="'sidebar-search-action-enter-amount' + row.article.articleNo.replace('/', '_')"
              [attr.data-articleno]="row.article.articleNo"/>
          }
          @if (showAddButton()) {
            <button class="btn btn-primary btn-icon"
                    (click)="executeArticleAction(row)"
                    tooltip tooltipPosition="bottom" [tooltipText]="'sidebar.search.configure' | translate"
                    data-gatm="sidebar.search.configure"
                    [id]="'sidebar-search-action-add-article' + row.article.articleNo.replace('/', '_')"
                    [attr.data-testid]="'add-article-' + row.article.articleNo"
                    [attr.data-articleno]="row.article.articleNo">
              <app-svg-icon type="caret-right" size="medium-small"/>
            </button>
          }
        </div>
      </ng-template>
    </app-table-column>
  </app-table>
</div>

